<template lang="pug">
	.station-streaming-encoders-list.tb-padding(v-if="stationId")
		ListView.full-width(ref="listView", initialView="table", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="() => items", :getData="loadData", :columns="columns")
			template(v-slot:listing-cell-template="{ data }")
				.flex-row.space.align-center
					DxButton(icon="close", @click="v => removeStreamingEncoder(data)", :disabled="!allowEdit")
					DxButton(icon="edit", @click="v => showStreamingEncoderPopup(data)", :disabled="!allowEdit")
					a(v-if="allowEdit", @click="v => showStreamingEncoderPopup(data)")
						span {{data.ServerTypeName}}
			template(slot="left-actions")
				.flex-row.space.align-center
					.font-large {{$tCaption('Streaming encoders')}}
					DxButton(icon="plus", @click="v => showStreamingEncoderPopup()", :disabled="!allowEdit")
		Popup(v-if="allowEdit && streamingEncoderPopup.visible && editingEncoder", :popupVisible="streamingEncoderPopup.visible", :width="840", :height="940")
			Detail(:streamingEncoder="editingEncoder", :serverTypes="serverTypes", :audioCodecTypes="audioCodecTypes", :flipBitBreakModes="flipBitBreakModes", :flipBitBreakTypes="flipBitBreakTypes", :flipBitSpotModes="flipBitSpotModes" :flipBitSpotTypes="flipBitSpotTypes")
			.flex-row.space(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="streamingEncoderPopup.visible = false", :disabled="!allowEdit")
				DxButton(v-if="editingEncoder.Oid" :text="$tCaption('Check encoder connection')" @click="checkEncoderConnection", :disabled="streamingEncoderPopup.processing && allowEdit")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="createUpdateStreamingEncoder", :disabled="streamingEncoderPopup.processing && allowEdit")
</template>

<script>
import _ from 'lodash';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import Popup from 'app-core/Popup.vue';
import Detail from './StreamingEncodersDetail.vue';

export default {
	translationCategory: 'station.StreamingEncodersList',
	name: 'station-streaming-encoders-list',
	components: { ListView, DxButton, Popup, Detail },
	props: ['stationId', 'allowEdit'],
	data() {
		const serverTypes = ['Shoutcastv1', 'Shoutcastv2', 'Icecastv1', 'Icecastv2', 'AdsWizz', 'TritonDigital'].map((f, i) => ({
			id: i,
			name: f
		}));
		const audioCodecTypes = ['AAC-LC', 'HE-AAC V1', 'HE-AAC V2', 'XHE-AAC', 'MP3'].map((f, i) => ({
			id: i,
			name: f
		}));
		const flipBitBreakModes = ['Low', 'High', 'Flip'].map((f, i) => ({
			id: i,
			name: f
		}));
		const flipBitBreakTypes = ['None', 'CopyRight', 'Original', 'Private'].map((f, i) => ({
			id: i,
			name: f
		}));
		const flipBitSpotModes = ['Low', 'High', 'Flip'].map((f, i) => ({
			id: i,
			name: f
		}));
		const flipBitSpotTypes = ['None', 'CopyRight', 'Original', 'Private'].map((f, i) => ({
			id: i,
			name: f
		}));


		return {
			serverTypes,
			audioCodecTypes,
			flipBitBreakModes,
			flipBitBreakTypes,
			flipBitSpotModes,
			flipBitSpotTypes,
			columns: [
				{ dataField: 'ServerTypeName', caption: () => this.$tCaption('Server type'), cellTemplate: 'listing-cell-template', serverField: 'Name'  },
				{ dataField: 'Bitrate', caption: () => this.$tCaption('Bitrate'), dataType: 'numeric' },
				{ dataField: 'SampleRate', caption: () => this.$tCaption('Sample rate'), dataType: 'numeric' },
				{ dataField: 'AudioCodecName', caption: () => this.$tCaption('Audio codec') },
				{ dataField: 'Host', caption: () => this.$tCaption('Host') },
				{ dataField: 'Port', caption: () => this.$tCaption('Port'), dataType: 'numeric' },
				{ dataField: 'MountPoint', caption: () => this.$tCaption('Mounting point') },
				{ dataField: 'ReconnectTimeOut', caption: () => this.$tCaption('Reconnect timeout'), dataType: 'numeric' },
				{ dataField: 'IsPublic', caption: () => this.$tCaption('Is public') },
				{ dataField: 'Enabled', caption: () => this.$tCaption('Enabled') },
				{ dataField: 'StreamingName', caption: () => this.$tCaption('Streaming name') },
				{ dataField: 'Streaming Url', caption: () => this.$tCaption('Streaming Url') },
				{ dataField: 'Streaming genre', caption: () => this.$tCaption('Streaming genre') },
				{ dataField: 'Streaming description', caption: () => this.$tCaption('Streaming description') },
				{ dataField: 'FlipBitBreakMode', caption: () => this.$tCaption('Flip bit break mode') },
				{ dataField: 'FlipBitBreakType', caption: () => this.$tCaption('Flip bit break type') },
				{ dataField: 'FlipBitSpotMode', caption: () => this.$tCaption('Flip bit spot mode') },
				{ dataField: 'FlipBitSpotType', caption: () => this.$tCaption('Flip bit spot type') },
			],
			result: null,
			allStreamingEncodersResult: null,
			streamingEncoderPopup: {
				visible: false,
				processing: false
			},
			editingEncoder: null
		};
	},
	computed: {
		items() {
			return this.result && this.result.Results.map(f => ({
				...f,
				ServerTypeName: this.getArrValue(this.serverTypes, f.ServerType || 0, 'name'),
				AudioCodecName: this.getArrValue(this.audioCodecTypes, f.AudioCodec || 0, 'name'),
				FlipBitBreakMode: this.getArrValue(this.flipBitBreakModes, f.AudioCodec || 0, 'name'),
				FlipBitBreakType: this.getArrValue(this.flipBitBreakTypes, f.AudioCodec || 0, 'name'),
				FlipBitSpotMode: this.getArrValue(this.flipBitSpotModes, f.AudioCodec || 0, 'name'),
				FlipBitSpotType: this.getArrValue(this.flipBitSpotTypes, f.AudioCodec || 0, 'name'),
			}));
		}
	},
	mounted() {
		if (__DEBUG__)
			window.streamingEncodersList = this;
	},
	methods: {
		getArrValue(arr, val, prop) {
			return arr[val] && arr[val][prop];
		},
		showStreamingEncoderPopup(data) {
			this.editingEncoder = _.clone(data || {
				StationId: this.stationId,
				ServerType: 0,
				StreamId: null,
				Bitrate: 64000,
				SampleRate: 48000,
				Port: 8000,
				ReconnectTimeOut: 30,
				MountPoint: '',
				UserName: '',
				Password: '',
				IsPublic: true,
				Enabled: true,
				StreamingName: '',
				StreamingDescription: '',
				StreamingGenre: '',
				StreamingUrl: '',
				FlipBitBreakMode: 0,
				FlipBitBreakType: 0,
				FlipBitSpotMode: 0,
				FlipBitSpotType: 0,
			});
			this.streamingEncoderPopup.visible = false;
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.streamingEncoderPopup.visible = true;
			});
		},
		removeStreamingEncoder(data) {
			this.$confirmMessage({
				title: () => this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to remove streaming encoder?'),
				handler: () => {
					this.$Data.getExternalApi(`Station/DeleteStationEncoder?streamingEncoderId=${data.Oid}&stationId=${data.StationId}`).then(r => {
						if (r.Success) {
							this.$notifySuccess(this.$tCaption('Streaming encoder removed'));
							this.$refs.listView.reload();
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					});
				}
			});
		},
		createUpdateStreamingEncoder(e) {
			if (__DEBUG__)
				console.debug('Crete new StreamingEncoder');
			if (!e.validationGroup.validate().isValid) {
				return;
			}
			this.streamingEncoderPopup.processing = true;
			this.$Data.postExternalApi('Station/CreateUpdateStationEncoder', this.editingEncoder).then(r => {
				if (r.Success) {
					this.$refs.listView.reload();
					this.$notifySuccess(this.$tCaption('Streaming encoder saved'));
				} else {
					this.$notifyError(r.ErrorMessage);
				}
				return r;
			}).finally(() => {
				this.streamingEncoderPopup.visible = false;
				this.streamingEncoderPopup.processing = false;
			});
		},
		loadData(pageIndex, size) {
			return this.$Data.getStationStreaminEncoders(this.stationId, pageIndex, size).then(r => {
				if (this._isDestroyed) return;
				if (__DEBUG__)
					console.debug('StreamingEncoders loaded', { r });
				this.result = r;
				return r;
			});
		},
		checkEncoderConnection() {
			this.streamingEncoderPopup.processing = true;
			this.$Data.getExternalApi('Station/CheckEncoderConnection', `serverId=${this.editingEncoder.Oid}`).then((r) => {
				if (r.Connected === "true") {
					this.$notifySuccess('Streaming encoder connected');
				} else {
					this.$notifyError('Connection failed');
				}
			}).finally(() => {
				this.streamingEncoderPopup.processing = false;
			});
		}
	}
};
</script>
<style lang="scss">
	.station-streaming-encoders-list {
		position: relative;

		.add-button {
			position: fixed;
			display: flex;
			align-items: center;
			justify-content: center;
			bottom: 40px;
			right: 40px;
			border-radius: 100px;
			width: 40px;
			height: 40px;
		}
	}
</style>
